import { GridCustomCellProps } from "@progress/kendo-react-grid";

const EmailCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;
  const email = props.dataItem[props.field];
    return (
      <td {...props.tdProps}>
          <a href={`mailto:${email}`} className="text-primary">{email}</a>
      </td>
    );
}

export default EmailCell;
